module.exports = __webpack_public_path__ + "img/p2-90.16892bdf.png";